import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ExportComponents from "../../Components/ExportComponents";
import Account from "../../Services/accountServices";
import USDFigure from "../../Components/USDFigure";

function TransactionLines(props) {
  const { journalId } = useParams();
  const [transactionLines, setTransactionLines] = useState([]);
  const fetchLines = () => {
    Account.getTransactionLines(journalId).then((line) => {
      console.log("Transaction Lines,", line.data);
      setTransactionLines(line.data);
    });
  };
  useEffect(() => {
    fetchLines();
  }, []);
  return (
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="page-header">
          <div class="row">
            <div class="col">
              <h3 class="page-title">Transactions Lines</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/genral-journel">General Journal</a>
                </li>
                <li class="breadcrumb-item active">Transaction Lines</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <ExportComponents />
            </div>
            <div>
              <p>
                <strong>Journal Entry: </strong>
                {transactionLines[0]?.generalJournalName}
              </p>
              <p>
                <strong>Date:</strong> {transactionLines[0]?.date}
              </p>
              <p>
                <strong>Ref:</strong> {transactionLines[0]?.ref}
              </p>
              <p>
                <strong>Note:</strong> {transactionLines[0]?.note}
              </p>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>S.no</th>
                        <th>Account Name</th>
                        <th>Debit</th>
                        <th>Credit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactionLines.map((item, index) => {
                        return (
                          <tr>
                            <th>{index + 1}</th>
                            <th>{item.accountName}</th>
                            <th>
                              <USDFigure amount={item.debit} />
                            </th>
                            <th>
                              <USDFigure amount={item.credit} />
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransactionLines;
